module.exports = __webpack_public_path__ + "images/cs-portfolio-8680471.png";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/slider-v1/images/cs-portfolio.png
// module id = 42
// module chunks = 2